import { render } from "./DocumentClassFieldTable.vue?vue&type=template&id=0679ad1c&scoped=true&ts=true"
import script from "./DocumentClassFieldTable.vue?vue&type=script&lang=ts"
export * from "./DocumentClassFieldTable.vue?vue&type=script&lang=ts"

import "./DocumentClassFieldTable.vue?vue&type=style&index=0&id=0679ad1c&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0679ad1c"]])

export default __exports__